import styled from 'styled-components'
import { themeGet } from 'styled-system'

export const StyledButton = styled.button.attrs(
  ({ isActive, showHeader, showMonitorViewOnly }) => ({
    background: isActive
      ? themeGet('colors.blue')
      : showMonitorViewOnly && !showHeader
      ? themeGet('colors.white')
      : themeGet('colors.paleGray'),
    color: isActive ? themeGet('colors.white') : themeGet('colors.darkGray'),
  }),
)`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  cursor: pointer;
  padding: 0.375rem 1.125rem 0.25rem;
  margin-right: 0.625rem;
  transition: all 0.2s ease;
  position: relative;
  height: 1.75rem;
  background-color: ${({ background }) => background};
  color: ${({ color }) => color};
  border-radius: 0.625rem;

  &:hover {
    background-color: ${({ isActive }) =>
      isActive ? themeGet('colors.blue') : themeGet('colors.darkBlue')};
    color: ${themeGet('colors.white')};
    transition: all 0.2s ease;
    cursor: ${({ isActive }) => (isActive ? 'default' : 'pointer')};
  }

  ${props =>
    props.isActive &&
    `
    &::after {
      content: '';
      position: absolute;
      bottom: -5px;
      left: 50%;
      transform: translateX(-50%);
      width: 0;
      height: 0;
      border-left: 0.5rem solid transparent;
      border-right: 0.5rem solid transparent;
      border-top: 0.5rem solid ${themeGet('colors.blue')(props)};
    }
  `}
`

export const Text = styled.span.attrs(({ isActive }) => ({
  fontFamily: isActive
    ? themeGet('font.molde.semibold')
    : themeGet('font.molde.regular'),
}))`
  font-size: 0.875rem;
  font-family: ${({ fontFamily }) => fontFamily};
  white-space: nowrap;
  text-align: center;
  line-height: 1.2;
`
